import type { UniclientImage } from '@lemonade-hq/uniclient-chat';
import { foundations } from '@lemonade-hq/uniclient-theme';
import { WizardComponentAdapter } from '../../WizardComponentAdapter';

const valueSize = (value?: number): string | undefined => (value != null ? `${value}px` : undefined);

export const WizardImage: React.FC<UniclientImage> = ({ alt, src, height, width, columns, id, borderRadius }) => (
  <WizardComponentAdapter
    alt={alt}
    as="img"
    className={foundations({ borderRadius: borderRadius ?? 'sm' })}
    height={columns != null ? undefined : valueSize(height)}
    id={id}
    src={src}
    type="image"
    width={columns != null ? '100%' : valueSize(width)}
  />
);
